const VALIDATIONS = {
    MUST_BE_NUMBER: "El valor debe ser númerico" ,
    MUST_SELECT_OPTION: "Debe seleccionar una opción"
}

export default VALIDATIONS